// Module
var code = "<div class=\"sb-edit__badge\" ng-class=\"vm.customClass\"> <span class=\"sb-edit__edited-label\" translate> {{vm.label}}</span> <md-tooltip md-direction=\"left\" class=\"sb-multiline-tooltip\"> {{vm.tooltip}} </md-tooltip> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/sbLabelBadge/sb_label_badge.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;